var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat2NewHair5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new-hair5_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M597.5,150.5c-7.6-22.6-25.8-48.8-43-67c-64.6-68.8-195.1-91.5-283-69c-70.6,18.1-124.6,85.9-150,152 c-13.4,34.7-20.2,63.9-20,101c0.1,24.6,7.8,70.4,23.3,90.9c5.2,15.2,15,26.4,30.9,26c-8.3-3.3-12.6-10.9-10.8-20.5 c5.3-12.6,24.7-19.6,23.2-35.8c-0.5-10.6-6-27-3.5-38.2c4-18.2,25.8-21.1,33.3-37.3h-0.2c3.5-6.8,2.7-15.1,9.7-21.2 c3.4-3,8-3,10.4-7.6c2.4-4.7,2.2-19.8,13.3-31c22.2-17.8,61.3-34.4,93.1-41.9c4.3-0.6,8.1-1,11.4-1.3c38.5-3.9,65.1-3.6,102,7.8 c15.7,4.8,36.5,7.2,51.7,16.1l10.6,39.8c-0.6,6.7,4.5,5.7,6.8,10.5c2.6,5.2,0.1,9,1.8,14.2c4.1,12.5,17.8,5.1,24,16 c6.6,11.7,0.4,14.2,14.7,19.3c6.6,2.3,11.9,3.6,15.8,8.5c4.5,8,3.4,19.3,4.5,26.6c1.4,8.8,9.6,10,12.9,17.8 c1.4,3.3,1.6,6.5,1.6,10.2l0.1-0.1v0.1c2.8-1.6,5.3-3.6,7.4-6v0.3C621.7,297.1,618.9,196.5,597.5,150.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat2_10_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M538.9,204.5c4.4-4.7,21.6-19.9,14.4-24.7c-105.4-18.8-214.5-23.4-321.7-10.7c-14.1,1.6-28.2,3.6-42.3,5.8 c-8,1.4-15.9,3-23.8,4.7c-1.8,4.6,5.1,12.5,7.6,15.5c4.7,5.6,9.6,11.5,15,16.5c6,5.6,13.6,10.4,20.9,10.5 c97.7-21.4,201.2-19.5,300.5-1.4C522.6,220.3,530.9,213,538.9,204.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M219.7,170.6c-10.1,1.3-20.2,2.7-30.3,4.3c-8,1.4-15.9,3-23.8,4.7c-1.8,4.6,5.1,12.5,7.6,15.5 c4.7,5.6,9.6,11.5,15,16.5c6,5.6,13.6,10.4,20.9,10.5c35.4-7.8,71.6-12.5,108.1-14.4C281.6,202.1,245.1,193.1,219.7,170.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M227.3,74.3c-11,28.1-18.9,67.1-20.2,98c8.2-1.1,16.3-2.2,24.5-3.1c93.4-11.1,188.2-9,280.8,4.2 c-2.8-36.2-8.8-71.8-20.9-105.4C422.1,48.7,307.6,41.3,227.3,74.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M227.3,74.3c-8.8,22.7-15.7,52.4-18.7,79.3c12.6-2.5,25.6-4.6,38.8-6.4c0.4-27.8,5.3-60,12.2-83.6 C248.4,66.5,237.6,70.1,227.3,74.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A110C",
    d: "M208.6,153.5c-0.7,6.5-1.2,12.7-1.5,18.7c8.2-1.1,16.3-2.2,24.5-3.1c93.4-11.1,188.2-9,280.8,4.2 c-0.4-5.7-1-11.4-1.6-17.1C419.3,135.4,304.3,134.8,208.6,153.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#947D70",
    d: "M458.4,146.8c-8.9-1.2-18-2.3-27.2-3.1l0.9,21.1c9.2,0.6,18.3,1.4,27.4,2.3L458.4,146.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat2NewHair5);
export default __webpack_public_path__ + "static/media/m-hat2_new-hair5.8c81ce34b384123c99385b5639873765.svg";
export { ForwardRef as ReactComponent };